// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateReasonForChange = reason => ({
    reason,
    type: actions.UPDATE_REASON_FOR_CHANGE
});



// WEBPACK FOOTER //
// ./src/product/new-transfer/action-creators/update-reason-for-change.js